import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight, Languages, QrCode, FileText } from "lucide-react";

/**
 * TrainingCenterCTA — operational spotlight strip pinned at the top of
 * every role hub that surfaces the Training Center as a first-class
 * platform module (not buried under "back-office tools"). Workforce
 * development is one of the strongest ForgedOps differentiators —
 * make sure every prospect hitting any hub sees it inside 5 seconds.
 */
export default function TrainingCenterCTA() {
  return (
    <section
      className="mt-4 mb-6 rounded-md overflow-hidden"
      style={{ background: "#0B0B0B", border: "1px solid #1A1A1A" }}
      data-testid="training-center-cta"
    >
      <div
        className="absolute"
        aria-hidden
        style={{
          width: 220, height: 220, borderRadius: 9999, filter: "blur(80px)",
          background: "radial-gradient(circle, rgba(255,106,0,0.18) 0%, rgba(255,106,0,0) 70%)",
          pointerEvents: "none",
        }}
      />
      <div className="relative flex items-center gap-4 p-5 sm:p-6 flex-wrap">
        <span
          className="inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-md shrink-0"
          style={{
            background: "rgba(255,106,0,0.14)",
            color: "#FF6A00",
            border: "1px solid rgba(255,106,0,0.45)",
          }}
        >
          <GraduationCap className="w-6 h-6" />
        </span>

        <div className="flex-1 min-w-0">
          <div
            className="font-mono text-[10px] uppercase tracking-[0.3em] mb-1"
            style={{ color: "#FF6A00" }}
          >
            Workforce Development · Training Center
          </div>
          <h3 className="font-display text-lg sm:text-xl font-black text-white leading-tight">
            Onboard, train, and certify the field — in any language, on any device.
          </h3>
          <p className="text-xs sm:text-sm mt-1.5 leading-relaxed" style={{ color: "#BDBDBD" }}>
            OSHA Outreach · Equipment & Operator · Safety Deployment · PM
            &amp; Field Leadership. Bilingual lessons, QR access, completion
            logs auto-routed to crew profiles.
          </p>
          <div className="mt-3 flex flex-wrap items-center gap-1.5">
            <Chip icon={Languages}>EN / ES</Chip>
            <Chip icon={QrCode}>QR Access</Chip>
            <Chip icon={FileText}>Cert + PDF</Chip>
            <Chip>4 tracks · 30+ lessons</Chip>
          </div>
        </div>

        <Link
          to="/training"
          className="inline-flex items-center gap-2 h-12 px-5 font-mono text-[11px] uppercase tracking-[0.3em] font-black rounded transition-colors shrink-0"
          style={{ background: "#FF6A00", color: "#000", border: "1px solid #FF6A00" }}
          data-testid="training-center-cta-open"
        >
          Open Training Center <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}

function Chip({ icon: Icon, children }) {
  return (
    <span
      className="font-mono text-[9px] uppercase tracking-[0.2em] px-2 py-1 rounded inline-flex items-center gap-1"
      style={{
        background: "#1A1A1A",
        color: "#FFFFFF",
        border: "1px solid #2A2A2A",
      }}
    >
      {Icon ? <Icon className="w-3 h-3" /> : null}
      {children}
    </span>
  );
}
